/**
 * Translation helpers for conditional text based on feature flags
 * Specifically handles the online presence vs websites naming feature flag
 */

import store from '@/store';

/**
 * Gets the appropriate translation key for "Online Presence" vs "Websites" based on feature flag
 * @param {String} baseKey - The base translation key without suffix
 * @returns {String} The appropriate translation key to use
 */
export const getOnlinePresenceTranslationKey = (baseKey) => {
  // Check if the feature flag is enabled (defaults to false)
  const useWebsitesNaming = store.getters['BusinessStore/hasFeature']('directory.business_administration.online_presence_naming');

  // Return appropriate key based on feature flag
  if (useWebsitesNaming) {
    return `${baseKey}_websites`;
  }

  return baseKey;
};

/**
 * Helper to get conditional translation text directly
 * @param {Object} vueInstance - Vue component instance with $t method
 * @param {String} baseKey - The base translation key
 * @returns {String} The translated text
 */
export const getConditionalTranslation = (vueInstance, baseKey) => {
  const key = getOnlinePresenceTranslationKey(baseKey);
  // eslint-disable-next-line
  return vueInstance.$t(key);
};

export default {
  getOnlinePresenceTranslationKey,
  getConditionalTranslation,
};
